import React from "react";
import { ItemCardImageDefault } from "./ItemCardImageDefault";

export const ItemCardInfo2FA = ({title, description}) => {
	return (
		<div className="item-card-info-bank">
			<p className="item-card-info-bank--title">{title}</p>
			<p className="item-card-info-bank--first-text">
				{description}
			</p>
			<strong>Seus dados estão seguros</strong>
            <p>
                Nossa plataforma é blindada e tem certificação de excelência em segurança. Aqui, seus dados estão protegidos.
            </p>
			<ItemCardImageDefault />
		</div>
	);
};
